import "./PointsTable.scss";
import { Row, Column } from "../columns";
import React, { useState, useEffect, useContext } from "react";
import Line from "../line/Line";
import { ThemeContext, themes } from "../theme/ThemeContext";
import { faCircleDot } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const { format } = require("date-fns");

const PointsTable = ({ license, activities, institution, branch }) => {
  const theme = useContext(ThemeContext);
  const [totalAmount, setTotalAmount] = useState();
  let tempTotalAmount = 0;
  let returnScreen = null;
  let activitiesSorted = 0;

  const [width, setWidth] = useState(window.innerWidth);
  const [selectedPeriod, setSelectedPeriod] = useState("Odaberi period");

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const isMobile = width <= 960;

  activitiesSorted = activities
    .sort((yearA, yearB) => (yearA.year > yearB.year ? 1 : -1))
    .reverse();

  useEffect(() => {
    for (const act of activities) {
      for (const item of act.items) {
        const newItem = item.pointsAmount.replace(",", ".");
        tempTotalAmount += parseFloat(newItem);
      }
    }
    setTotalAmount(parseFloat(tempTotalAmount));
  }, [activities]);

  const selectBoxOnChangeHandler = (e) => {
    setSelectedPeriod(e.target.value);
  };

  let upperPartOfScreen = null;

  if (totalAmount === 0 || totalAmount === undefined) {
    upperPartOfScreen = (
      <>
        <div>
          <Row>
            <Column className="has-text-centered has-text-weight-bold mb-5 pr-0 navi-exception">
              <FontAwesomeIcon
                size="3x"
                className={`has-text-${theme.purpleWarning}`}
                style={{ fontSize: "8em" }}
                icon={faExclamationTriangle}
              />
            </Column>
          </Row>
          <Row className="mt-5">
            <Column className="has-text-centered has-text-weight-bold mb-5 pr-0 navi-exception is-size-4">
              Za aktivno razdoblje nema skupljenih bodova!
            </Column>
          </Row>
          <Row>
            <Column className="has-text-weight-bold has-text-centered mb-5 pr-0 navi-exception is-size-6">
              Za sva pitanja vezana za Vaše bodove molimo kontaktirajte nas.
            </Column>
          </Row>
        </div>
      </>
    );
  } else {
    // Used for mobile view
    upperPartOfScreen = (
      <>
        <Row>
          <Column className="has-text-centered mb-5 pr-0 bigger-letters navi-exception">
            {branch}
          </Column>
        </Row>
        <Row>
          <Column className="has-text-centered has-text-weight-bold mb-5 pr-0 bigger-letters navi-exception">
            {institution}
          </Column>
        </Row>
        <Row>
          <Column className="has-text-centered mb-5 pr-0 bigger-letters navi-exception">
            Licenca: {license}
          </Column>
        </Row>
        <Row>
          <Column className="total-amount has-text-centered mb-5 pr-0 bigger-letters navi-exception">
            Ukupan broj bodova: {totalAmount}
          </Column>
        </Row>
        <Row>
          <Column className="mb-3 has-text-centered navi-exception">
            <div className="select">
              <select onChange={selectBoxOnChangeHandler} value={selectedPeriod}>
                <option key={Math.random()}>Odaberi period</option>
                {activitiesSorted.map((act) => {
                  return <option key={Math.random()}>{act.year}</option>;
                })}
              </select>
            </div>
          </Column>
        </Row>
      </>
    );
  }

  // Mobile view
  if (isMobile) {
    // Get activities by selected period, then sort it by date
    let activitiesSortedMobile = [];
    activitiesSorted.find((act) => {
      if (act.year === selectedPeriod) {
        act.items.map((item) => {
          activitiesSortedMobile.push(item);
        });
      }
    });
    // Convert strings to dates for comparator
    const arrayTemp = activitiesSortedMobile.map((obj) => {
      return { ...obj, date: new Date(obj.date) };
    });

    // Sort dates desc
    const activitiesSortedMobileSortedDesc = arrayTemp.sort(
      (objA, objB) => Number(objB.date) - Number(objA.date)
    );

    // Mobile view
    returnScreen = (
      <div className="">
        {upperPartOfScreen}
        {activitiesSorted.map((activity, index) => {
          if (activity.year === selectedPeriod) {
            return (
              <React.Fragment key={index}>
                <div className="has-text-centered table-content">
                  <div className="mt-4 has-text-weight-bold">{activity.year}</div>

                  <Column className="">
                    {activitiesSortedMobileSortedDesc.map((item, key) => (
                      <React.Fragment key={key}>
                        <div
                          style={{
                            padding: "0.75rem",
                            paddingTop: "1.5rem",
                            paddingBottom: "1.5rem",
                          }}
                        >
                          <div>
                            <div className="card cardStyle">
                              <div className="card-content">
                                <Column className="has-text-left">
                                  {<p className="headers-mobile">Datum aktivnosti: </p>}
                                  {format(new Date(item.date), "dd/MM/yyyy")}
                                </Column>
                                <Column className="has-text-left">
                                  {<p className="headers-mobile">Naziv aktivnosti: </p>}
                                  {item.name}
                                </Column>
                                <Column className="has-text-left">
                                  {<p className="headers-mobile">Vrsta aktivnosti: </p>}
                                  {item.activityType}
                                </Column>
                                <Column className="has-text-left">
                                  {<p className="headers-mobile">Ustanova: </p>}
                                  {item.institution}
                                </Column>
                                <Column className="has-text-left">
                                  {<p className="headers-mobile">Status: </p>}
                                  {item.status}
                                </Column>
                                <Column className="has-text-left">
                                  {<p className="headers-mobile">Broj bodova: </p>}
                                  {item.pointsAmount}
                                </Column>
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                  </Column>
                </div>
              </React.Fragment>
            );
          } else {
            return <p key={Math.random()}></p>;
          }
        })}
      </div>
    );
    // Desktop view
  } else {
    if (totalAmount === 0) {
      returnScreen = (
        <div className="no-points-screen">
          <Row className="mt-5 mr-5 is-justify-content-flex-end" isGapless={true}>
            {license && <div className="biggger-spacing">Licenca: {license}</div>}
          </Row>
          <div className="biggger-spacing">{upperPartOfScreen}</div>
        </div>
      );
    } else {
      returnScreen = (
        <div className="parent">
          <div className="mb-5 account-points-info">
            <Row className="mt-5 is-justify-content-flex-end" isGapless={true}>
              <div className="">{branch}</div>
            </Row>
            <Row className="mt-5 is-justify-content-flex-end" isGapless={true}>
              <div className="">{institution}</div>
            </Row>
            <Row className="mt-5 is-justify-content-flex-end" isGapless={true}>
              <div className="">Licenca: {license}</div>
            </Row>
          </div>

          <Row className="table-headers-row" key={Math.random()}>
            <Column className="is-2 has-text-centered"></Column>
            <Column className="has-text-centered">Datum aktivnosti</Column>
            <Column className="has-text-left">Naziv aktivnosti</Column>
            <Column className="has-text-left">Vrsta aktivnosti</Column>
            <Column className="has-text-left">Ustanova</Column>
            <Column className="has-text-left">Status</Column>
            <Column className="has-text-centered">Broj bodova</Column>
          </Row>
          {activitiesSorted.map((activity, index) => (
            <React.Fragment key={index}>
              <Row className="has-text-centered table-content" key={Math.random()}>
                <Column className="is-2 border is-flex py-0">
                  <div className="is-flex-grow-1 timeline-date">{activity.year}</div>
                  <div className="is-flex is-flex-direction-column ">
                    <FontAwesomeIcon
                      size="2x"
                      className={`has-text-${theme.purpleCircle} `}
                      icon={faCircleDot}
                    />
                    {index !== activities.length ? <div className="timeline-line" /> : null}{" "}
                  </div>
                </Column>
                <Column className="is-10">
                  {index === 0 ? (
                    ""
                  ) : (
                    <Line
                      className="separator-line mb-5"
                      height={1}
                      color={theme.tableSeparatorLine}
                    />
                  )}
                  {activity.items.map((item, key) => (
                    <React.Fragment key={key}>
                      <Row>
                        <Column className="has-text-centered">
                          {format(new Date(item.date), "dd/MM/yyyy")}
                        </Column>
                        <Column className="has-text-left">{item.name}</Column>
                        <Column className="has-text-left">{item.activityType}</Column>
                        <Column className="has-text-left">{item.institution}</Column>
                        <Column className="has-text-left">{item.status}</Column>
                        <Column className="has-text-centered">{item.pointsAmount}</Column>
                      </Row>
                    </React.Fragment>
                  ))}
                </Column>
              </Row>
            </React.Fragment>
          ))}
          <Row className="has-text-centered table-content" key={Math.random()}>
            <Column className="is-2 border is-flex py-0">
              <div className="is-flex-grow-1 timeline-date">{"" /*ZADNJA GODINA U NIZU*/}</div>
              <div className="is-flex is-flex-direction-column ">
                <FontAwesomeIcon
                  size="2x"
                  className={`has-text-${theme.purpleCircle} `}
                  icon={faCircleDot}
                />
              </div>
            </Column>
            <Column className="is-10">
              <Line className="separator-line mb-5" height={1} color={theme.tableSeparatorLine} />
              <>
                <Row>
                  <Column className="has-text-centered">{}</Column>
                  <Column className="has-text-left">{}</Column>
                  <Column className="has-text-left">{}</Column>
                  <Column className="has-text-left">{}</Column>
                  <Column className="has-text-left">{}</Column>
                  <Column className="has-text-centered">{}</Column>
                </Row>
              </>
            </Column>
          </Row>
          <Row className="has-text-centered table-content" key={Math.random()}>
            <Column className="is-2 border"></Column>
            <Column className="is-10">
              <Row>
                <Column className="has-text-centered"></Column>
              </Row>
              {/* <Line className="last-line" height={1} color={theme.tableSeparatorLineDark}></Line> ZADNJA-BOLD-LINIJA */}
              <Column className="has-text-right total-amount mb-7">Ukupno: {totalAmount}</Column>
            </Column>
          </Row>
        </div>
      );
    }
  }

  return returnScreen;
};

export default PointsTable;
